  import { withRouter } from 'react-router-dom';
  import WithSystem from '../service/WithSystem';
  const certificateFilter = [{"id":"1","name":"Active"},{"id":"2","name":"Expired"}];
  class CertificateStatusDropDown extends React.Component {
    constructor(props) {
      super(props);
      this.box = React.createRef();
      this.state = { dropdownToggle: false }
    }
    setcertificateStatusItems = (selectedId, event) => {
      let certificateStatus = this.props.queryFilter.certificateStatus;
      certificateStatus = certificateStatus ? certificateStatus.split(',') : [];
      if (event.target.checked) {
        certificateStatus = certificateStatus.length ? [...certificateStatus, selectedId] : [selectedId];
      } else {
        certificateStatus = certificateStatus.filter((branch) => {
          return (branch != selectedId);
        });
      }
      certificateStatus = certificateStatus.length ? certificateStatus.join() : false;
      this.props.setGlobalState({ certificateStatus });
    }
    SetDropdownToggleVall = () => {
      this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
        document.addEventListener('click', this.handleOutsideClick);
      });
    }
    handleOutsideClick = (event) => {
      if (this.box && !this.box.current.contains(event.target)) {
        this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
          if (this.state.dropdownToggle == true) {
            this.setState({ dropdownToggle: false });
          }
          document.removeEventListener('click', this.handleOutsideClick);
        });
      }
    }
    
    render() {
      const CertificateStatusItems = this.props.queryFilter['certificateStatus'] ? this.props.queryFilter['certificateStatus'].split(',') : [];
      return (
        <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list active' : 'branch-list'}>
          <span className="filter-subtxt">Certificate Status</span>
          <div className="report-list-menu" >
            <div className="branch-list-sec">Select Status</div>
            <div className="list_menu_section" >
              <ul className="list_menu">
              {certificateFilter.map((course) => {
                let hasChecked = CertificateStatusItems.includes(course.id);
                return (
                  <li key={`certificateStatus_${course.id}`}><label htmlFor={`certificateStatus_${course.id}`}>
                   <span>
                      <input id={`certificateStatus_${course.id}`} onClick={(e) => this.setcertificateStatusItems(`${course.id}`, e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                    <span className="checkedmark"></span>
                  </span>
                    <span className="dropdownlist_singleline">{course.name}</span></label></li>)
              })}
            </ul>
            </div>
          </div>
        </div>
      );
    }
  }
  export default withRouter(WithSystem(CertificateStatusDropDown));
